import React,{useContext} from 'react'
import { ProductContext } from './Productcontext';
//import { Link,useNavigate } from 'react-router-dom';
import Link from 'next/link'
import eplogo from '../images/earthingcategory/earthing_logo.png';
import eplogo2x from '../images/earthingcategory/earthing_logo@2x.png';

import hotdip2x from '../images/earthingcategory/hotdip@2x.png';
import zinc2x from '../images/earthingcategory/zinc@2x.png';
import pvd2x from '../images/earthingcategory/pvd@2x.png';



import alloy2x from '../images/earthingcategory/alloy_coated@2x.png';
import copper2x from '../images/earthingcategory/copper_plated@2x.png';
import cbr2x from '../images/earthingcategory/copper_bonded_rod@2x.png';



import coat2x from '../images/earthingcategory/carbon_coating@2x.png';

import ccost2x from '../images/earthingcategory/conducto_cast@2x.png';

import acc2x from '../images/earthingcategory/earthing_accessories@2x.png';
import Image from 'next/image';

import { useRouter } from 'next/navigation';
const customStyles = `
.max-height-percentage {
  max-height: 80%; /* Adjust the percentage as needed */
}
`;

const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Smooth scrolling animation
    });
  };

const SafeearthingelectrodeContent = () => {
    //let navigate = useNavigate();
    let router = useRouter();
    const {selectedCategory,setCategory,selectedProduct, setProduct} = useContext(ProductContext);
    const roundedbottom={
        borderBottomLeft:10,
        borderBottomRight:10

      }
      const handleItemClick = (item) => {
       setCategory('earthing');
       
       
       localStorage.setItem('selectedProduct', item);
       setProduct(item);
      // console.log(item);
       //console.log('localStorage updated with:', localStorage.getItem('selectedProduct'));
    //    navigate('/eedetails');
    if(item=='cc_aseel')
        router.push('/ashlok-composite-carbon-coating');
    else if(item=='cfc_aseel')
        router.push('/ashlok-carbo-form-conducto-casting');
    else if(item=='cp_aseel')
        router.push('/ashlok-copper-plated-electrodes');
    else if(item=='a_aseel')
        router.push('/ashlok-alloy-coated-electrodes');
    else if(item=='pvd_aseel')
        router.push('/ashlok-pvd-150-coated');
    else if(item=='z_aseel')
        router.push('/ashlok-zinc-coated-electrodes');
    else if(item=='hd_aseel')
        router.push('/ashlok-galvanized-electrodes');
    else if(item=='cbr_aseel')
        router.push('/ashlok-copper-bonded-rods');
    else if(item=='earth_acc')
        router.push('/ashlok-earthing-accessories');
    else
        router.push('/ashlok-composite-carbon-coating');
 
   
   
       scrollToTop();
         /*if(item=='hd_aseel')
         navigate('');*/
      };
return (

    <div className=' w-full flex-col mx-auto flex justify-center items-center my-10 px-2 lg:px-0'>
        <style>{customStyles}</style>
    <Image src={eplogo} alt="Excellence in Retailed Earthing: Ashlok Safe Earthing Electrode excellence in earthing product retail"/>
    <h1 class="hidden">Chemical Earthing Electrode Manufacturer — Since 1999</h1>
  
    {/* First row */}
    <div className='container w-max-xl flex flex-col md-small:flex-row md:flex-row lg:flex-row justify-center mt-5  lg:m-5 lg:mt-10 lg:space-x-16 px-2 lg:px-0 '>
        <div className='flex flex-col w-full  lg:w-1/5 border bg-ashgray1 rounded-lg cursor-pointer justify-end  md-small:mx-2 md:mx-2 my-2 lg:my-0' style={{border:'black 1px solid',borderRadius:4}} onClick={() => handleItemClick('cc_aseel')}>
            <div className=' flex justify-center items-center '>
                <Image src={coat2x} alt="Ashlok Safe Earthing Electrode Limited Carbon Coated Earthing Electrode"
                srcSet={`${coat2x} 1x, ${coat2x}2x`}/>
            </div>
            <div className="p-4 text-center sm:text-left bg-ashblack text-white rounded-sm">
          
                <p className="text-l font-bold line-clamp-2 text-center"><span className='vollkorn-sc-semibold'>ASEEL CC | Composite Carbon Coating Technology</span></p>
               {/*
                <p className="text-base line-clamp-3 indent-10">Ashlok’s composite carbon coating : advanced technology for superior grounding.</p>
                <p className=" text-ashblack text-base">Ashlok’s composite carbon coating</p>
             
                    <Link to="/carboncoateearthdetails">
                    <div className='flex justify-end items-end'>
                        <div className='p-2   h-8  bg-ashred text-xs text-white flex items-center justify-center rounded-md'>Explore
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="12" height="12" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <polygon points="5 3 19 12 5 21 5 3"></polygon>
                            </svg>
                        </div>
                    </div>
                </Link>*/}
            </div>
        </div>
        <div className='flex flex-col w-full lg:w-1/5 border bg-ashgray1 rounded-lg  cursor-pointer justify-end md-small:mx-2  md:mx-2 my-2 lg:my-0' style={{border:'black 1px solid',borderRadius:4}} onClick={() => handleItemClick('cfc_aseel')}>
            <div className=' flex justify-center items-center'>
                <Image src={ccost2x} alt="Ashlok Safe Earthing Electrode Limited Conducto Cast Lightning Rod Base"
                srcSet={`${ccost2x} 1x, ${ccost2x}2x`}/>
            </div>
            <div className="p-4 text-center sm:text-left bg-ashblack text-white rounded-sm">
               
                <p className="text-l font-bold line-clamp-2 text-center"><span className='vollkorn-sc-semibold'>ASEEL CFC | CarboForm ConductoCasting</span></p>
                    {/*
                <p className="text-base line-clamp-3 indent-10">Ashlok singleton earthing ecosystem : seamless integration for optimal grounding.</p>
                <p className="text-base text-ashblack"> Ashlok singleton earthing ecosystem.</p>
                 
                    <Link to="/carbonformearthdetails">
                    <div className='flex justify-end items-end'>
                        <div className='p-2   h-8  bg-ashred text-xs text-white flex items-center justify-center rounded-md'>Explore
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="12" height="12" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <polygon points="5 3 19 12 5 21 5 3"></polygon>
                            </svg>
                        </div>
                    </div>
                </Link>*/}
            </div>
        </div>

        <div className='flex flex-col w-full lg:w-1/5 border bg-ashgray1 rounded-lg  cursor-pointer justify-end md-small:mx-2  md:mx-2 my-2 lg:my-0' style={{border:'black 1px solid',borderRadius:4}} onClick={() => handleItemClick('cp_aseel')}>
            <div className=' flex justify-center items-center'>
                <Image src={copper2x} alt="Copper Plated Earthing Electrode for Industrial"
                srcSet={`${copper2x} 1x, ${copper2x}2x`}/>
            </div>
            <div className="p-4 text-center sm:text-left bg-ashblack text-white rounded-sm">
                <div className="text-l font-bold line-clamp-2 text-center"><span className='vollkorn-sc-semibold'>ASEEL CP | Copper Plated</span> <p className=' text-ashblack'>ASEEL CP | Copper Plated</p></div>
               {/*
                <p className="text-xl font-bold  text-ashblack ">ASEEL HD | Galvanized</p>
                <p className="text-base line-clamp-3 indent-10">Ashlok copper plated earthing electrodes : reliable grounding for safety and efficiency.</p>
                    <Link to="/copperplateearthdetails">
                    <div className='flex justify-end items-end'>
                        <div className='p-2   h-8  bg-ashred text-xs text-white flex items-center justify-center rounded-md'>Explore
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="12" height="12" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <polygon points="5 3 19 12 5 21 5 3"></polygon>
                            </svg>
                        </div>
                    </div>
                </Link>*/}
            </div>
        </div>
        
        
    </div>
    {/* second row */}
    <div className='container w-max-xl flex flex-col md-small:flex-row md:flex-row lg:flex-row justify-center items-center lg:m-5 lg:mt-10 lg:space-x-16 cursor-pointer px-2 lg:px-0' >
        
        <div className='flex flex-col w-full lg:w-1/5 border bg-ashgray1 rounded-lg  cursor-pointer justify-end md-small:mx-2  md:mx-2 my-2 lg:my-0' style={{border:'black 1px solid',borderRadius:4}} onClick={() => handleItemClick('a_aseel')}>
            <div className=' flex justify-center items-center'>
                <Image src={alloy2x} alt="Ashlok Safe Earthing Electrode Limited Alloy Coated Earthing Electrode"
                srcSet={`${alloy2x} 1x, ${alloy2x}2x`}/>
            </div>
            <div className="p-4 text-center sm:text-left bg-ashblack text-white rounded-sm">
                <p className="text-l font-bold line-clamp-2 text-center"><span className='vollkorn-sc-semibold'>ASEEL A | Alloy Coated</span></p>
                {/*
                <p className="text-xl font-bold  text-ashblack ">ASEEL HD | Galvanized</p>
                <p className="text-base line-clamp-2 indent-10">Ashlok alloy coated earthing electrodes : ultimate protection.</p>
                <p className=" text-ashblack text-base">Ashlok alloy coated earthing</p>
                    <Link to="/alloyearthdetails">
                    <div className='flex justify-end items-end'>
                        <div className='p-2   h-8  bg-ashred text-xs text-white flex items-center justify-center rounded-md'>Explore
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="12" height="12" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <polygon points="5 3 19 12 5 21 5 3"></polygon>
                            </svg>
                        </div>
                    </div>
                </Link>*/}
            </div>
        </div>
        <div className='flex flex-col w-full lg:w-1/5 border bg-ashgray1 rounded-lg cursor-pointer justify-end  md-small:mx-2  md:mx-2 my-2 lg:my-0' style={{border:'black 1px solid',borderRadius:4}} onClick={() => handleItemClick('pvd_aseel')}>
            <div className=' flex justify-center items-center'>
                <Image src={pvd2x} alt="Ashlok Safe Earthing Electrode Limited PVD Coated Earthing Electrode for Corrosion Resistance "
                srcSet={`${pvd2x} 1x, ${pvd2x}2x`}/>
            </div>
            <div className="p-4 text-center sm:text-left bg-ashblack text-white rounded-sm ">
                <p className="text-l font-bold lg:line-clamp-1 text-center"><span className='vollkorn-sc-semibold'>ASEEL PVD | Zinc 150+</span></p>
                {/*
                <p className=" text-ashblack text-xl font-bold">ASEEL PVD</p>
                <p className="text-base line-clamp-2 indent-10">Ashlok pvd earthing electrodes : precision grounding</p>
              
                    <Link to="/pvdearthdetails">
                    <div className='flex justify-end items-end'>
                        <div className='p-2   h-8  bg-ashred text-xs text-white flex items-center justify-center rounded-md'>Explore
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="12" height="12" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <polygon points="5 3 19 12 5 21 5 3"></polygon>
                            </svg>
                        </div>
                    </div>
                </Link>*/}
            </div>
        </div>
        <div className='flex flex-col w-full lg:w-1/5 border bg-ashgray1 rounded-lg cursor-pointer justify-end md-small:mx-2  md:mx-2 my-2 lg:my-0' style={{border:'black 1px solid',borderRadius:4}} onClick={() => handleItemClick('z_aseel')}>
            <div className=' flex justify-center items-center'>
                <Image src={zinc2x} alt="Ashlok Safe Earthing Electrode Limited Zinc Coated Earthing Electrode for Heavy Industrial Use"
                srcSet={`${zinc2x} 1x, ${zinc2x}2x`}/>
            </div>
            <div className="p-4 text-center sm:text-left bg-ashblack text-white rounded-sm">
                <p className="text-l font-bold line-clamp-2 text-center"><span className='vollkorn-sc-semibold'>ASEEL Z | Zinc Coated</span></p>
               {/*
                <p className="text-xl font-bold  text-ashblack ">ASEEL HD | Galvanized</p>
                <p className="text-base line-clamp-2 indent-10">Ashlok zinc coated earthing electrodes : premium protection.</p>
                 <Link to="/zincearthdetails">
                    <div className='flex justify-end items-end'>
                        <div className='p-2   h-8  bg-ashred text-xs text-white flex items-center justify-center rounded-md'>Explore
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="12" height="12" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <polygon points="5 3 19 12 5 21 5 3"></polygon>
                            </svg>
                        </div>
                    </div>
                    </Link>*/}
            </div>
        </div>
        

    </div>
    {/* Third row */}
    <div className='container w-max-xl flex flex-col md-small:flex-row md:flex-row lg:flex-row justify-center  lg:m-5 lg:mt-10 lg:space-x-16 px-2 lg:px-0'>
       
        <div className='flex flex-col w-full lg:w-1/5 border bg-ashgray1 rounded-lg  cursor-pointer justify-end md-small:mx-2  md:mx-2 my-2 lg:my-0' style={{border:'black 1px solid',borderRadius:4}} onClick={() => handleItemClick('hd_aseel')}>
            <div className=' flex justify-center items-center'>
                <Image src={hotdip2x} alt="Hot Dip Galvanized Safe Earthing Electrode - Ashlok Safe Earthing Electrode Limited"
                srcSet={`${hotdip2x} 1x, ${hotdip2x}2x`}/>
            </div>
            <div className="p-4 text-center sm:text-left bg-ashblack text-white rounded-sm">
                <p className="text-l font-bold line-clamp-2 text-center" ><span className='vollkorn-sc-semibold'>ASEEL HD | Galvanized</span></p>
                {/*                    <p className="text-xl font-bold  text-ashblack ">ASEEL HD | Galvanized</p>
                <p className="text-base line-clamp-2 indent-10">Ashlok’s hotdip earthing electrode(s) : superior grounding.</p>
                    
                
                    <div className='flex justify-end items-end'>
                        <div className='p-2   h-8  bg-ashred text-xs text-white flex items-center justify-center rounded-md'>Explore
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="12" height="12" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <polygon points="5 3 19 12 5 21 5 3"></polygon>
                            </svg>
                        </div>
                        </div>*/}
                
            </div>
        </div>



        <div className='flex flex-col w-full lg:w-1/5 border bg-ashgray1 rounded-lg cursor-pointer justify-end md-small:mx-2  md:mx-2 my-2 lg:my-0' style={{border:'black 1px solid',borderRadius:4}} onClick={() => handleItemClick('cbr_aseel')}>
            <div className=' flex justify-center items-center'>
                <Image src={cbr2x} alt="Copper Bonded Grounding Rod - Ashlok Safe Earthing Electrode Limited"
                srcSet={`${cbr2x} 1x, ${cbr2x}2x`}/>
            </div>
            <div className="p-4 text-center sm:text-left bg-ashblack text-white rounded-sm">
                <p className="text-l font-bold line-clamp-2 md:line-clamp-1 text-center"><span className='vollkorn-sc-semibold'>ASEEL CBR | Copper Bonded Rod</span></p>
               {/*
                <p className="text-base line-clamp-3 indent-10">Ashlok copper bonded rods : reliable grounding solutions for enhanced safety.</p>
                    <Link to="/cbrearthdetails">
                    <div className='flex justify-end items-end'>
                        <div className='p-2   h-8  bg-ashred text-xs text-white flex items-center justify-center rounded-md'>Explore
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="12" height="12" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <polygon points="5 3 19 12 5 21 5 3"></polygon>
                            </svg>
                        </div>
                    </div>
                </Link>*/}
            </div>
        </div>

        <div className='flex flex-col w-full lg:w-1/5 border bg-ashgray1 rounded-lg  cursor-pointer justify-end md-small:mx-2  md:mx-2 my-2 lg:my-0' style={{border:'black 1px solid',borderRadius:4}} onClick={() => handleItemClick('earth_acc')}>
            <div className=' flex justify-center items-center'>
                <Image src={acc2x} alt="Ashlok Safe Earthing Electrode Limited Earthing Accessories for Lightning Protection"
                srcSet={`${acc2x} 1x, ${acc2x}2x`}/>
            </div>
            <div className="p-4 text-center sm:text-left bg-ashblack text-white rounded-sm">
                
                <p className="text-l font-bold line-clamp-2 md:line-clamp-1 text-center"><span className='vollkorn-sc-semibold text-center'>Earthing Accessories</span> </p>
                {/*
                <p className="text-xl font-bold text-ashblack">Earthing Accessories</p>
                <p className="text-base line-clamp-2 indent-10">Ashlok earthing accessories : enhancing safety and efficiency.</p>
                <p className="text-base text-ashblack"> Ashlok singleton earthing ecosystem. eco system232 Ashlok singleton</p>
                 </div>
                    <Link to="/carbonformearthdetails">
                    <div className='flex justify-end items-end'>
                        <div className='p-2   h-8  bg-ashred text-xs text-white flex items-center justify-center rounded-md'>Explore
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="12" height="12" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <polygon points="5 3 19 12 5 21 5 3"></polygon>
                            </svg>
                        </div>
                    </div>
                </Link>*/}
            </div>
        </div>

    </div>

    {/* hide content */}
    <div>
            <p className="sr-only">earth electrode</p>
            <p className="sr-only">earthing electrode manufacturer</p>
            <p className="sr-only">copper bonded rods</p>
            <p className="sr-only">copper bonded earthing electrode</p>
            <p className="sr-only">copper plated</p>
            <p className="sr-only">alloy coated</p>
        </div>
   

    

</div>
)
}

export default SafeearthingelectrodeContent

    